module.exports = __webpack_public_path__ + "media/images/admin/icons/minus-circle-e04118c7e5f1ff662691ab3cc9d2dd1d.svg";